import { useAppContext } from "@/context/AppContext";

export const GroundPlacementUI = () => {
  const { isGroundMode } = useAppContext();

  if (!isGroundMode) {
    return null;
  }

  return (
    <>
      Ground Placement UI
      {/* Your Ground Placement UI components go here */}
    </>
  );
};

export default GroundPlacementUI;